import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Uebersicht } from './pages/Uebersicht';
import { Werkstatt } from './pages/Werkstatt';
import { Detail } from './pages/Detail';
import { NeuerAuftrag } from './pages/NeuerAuftrag';
import { Laufraeder }  from './pages/Laufraeder';
import { Baugruppen }  from './pages/Baugruppen';
import { Montage }     from './pages/Montage';
import { LaserKant }   from './pages/LaserKant';
import { Einstellungen } from './pages/Einstellungen';
import { AbteilungDetail } from './pages/AbteilungDetail';
import { QS } from './pages/QS';
import AdminBackups from './pages/AdminBackups';
import Statistik from './pages/Statistik';
import { NeuerAuftragModul } from './pages/NeuerAuftragModul';
import Kapazitaeten from './pages/Kapazitaeten';
import { ModulDetail } from './pages/ModulDetail';
import Wareneingang from './pages/Wareneingang';
import { Blechbedarf } from './pages/Blechbedarf';
import { Lieferanten } from './pages/Lieferanten';
import { EinkaufDashboard } from './pages/EinkaufDashboard';
import KundenInfo from './pages/KundenInfo';
import Kunden from './pages/Kunden';
import { Tickets } from './pages/Tickets';
import { MeineTickets } from './pages/MeineTickets';
import { EinkaufSonstiges } from './pages/EinkaufSonstiges';
import { GasBestellung } from './pages/GasBestellung';
import { SammelBestellung } from './pages/SammelBestellung';
import { SammelZettel } from './pages/SammelZettel';
import { Artikelstamm } from './pages/Artikelstamm';
import { Sonderteile } from './pages/Sonderteile';

// Alte Links (/sammelbestellung/:id) → /banf/:id
function SammelZettelUmleitung() { const { id } = useParams(); return <Navigate to={`/banf/${id}`} replace />; }

export default function App() {
  return (
    <Routes>
      {/* Admin-Seite außerhalb des Layout — eigener Passwort-Gate */}
      <Route path="/admin/backups" element={<AdminBackups />} />
      <Route path="/" element={<Layout />}>
        {/* Modul-Hosts (blechbedarf/einkauf) öffnen direkt das jeweilige Modul.
            Assets werden vor dem Worker ausgeliefert, daher Redirect im Client. */}
        <Route index element={<Navigate to={
          typeof window !== 'undefined' && window.location.hostname.startsWith('blechbedarf.')
            ? '/blechbedarf'
            : typeof window !== 'undefined' && window.location.hostname.startsWith('einkauf.')
              ? '/einkauf'
              : typeof window !== 'undefined' && window.location.hostname.startsWith('tickets.')
                ? '/tickets' : '/dashboard'
        } replace />} />
        <Route path="einkauf" element={<EinkaufDashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="drueckteile" element={<Uebersicht />} />
        <Route path="drueckteile/neu" element={<NeuerAuftrag />} />
        <Route path="drueckteile/:id" element={<Detail />} />
        <Route path="laufraeder"  element={<Laufraeder />} />
        <Route path="laufraeder/neu" element={<NeuerAuftragModul modul="laufraeder" />} />
        <Route path="laufraeder/:id" element={<ModulDetail modul="laufraeder" />} />
        <Route path="baugruppen"  element={<Baugruppen />} />
        <Route path="baugruppen/neu" element={<NeuerAuftragModul modul="baugruppen" />} />
        <Route path="baugruppen/:id" element={<ModulDetail modul="baugruppen" />} />
        <Route path="montage"     element={<Montage />} />
        <Route path="montage/neu" element={<NeuerAuftragModul modul="montage" />} />
        <Route path="montage/:id" element={<ModulDetail modul="montage" />} />
        <Route path="laser_kant"     element={<LaserKant />} />
        <Route path="laser_kant/neu" element={<NeuerAuftragModul modul="laser_kant" />} />
        <Route path="laser_kant/:id" element={<ModulDetail modul="laser_kant" />} />
        <Route path="abteilung/:id" element={<AbteilungDetail />} />
        <Route path="werkstatt" element={<Werkstatt />} />
        <Route path="qs" element={<QS />} />
        <Route path="statistik" element={<Statistik />} />
        <Route path="kapazitaeten" element={<Kapazitaeten />} />
        <Route path="wareneingang" element={<Wareneingang />} />
        <Route path="blechbedarf" element={<Blechbedarf />} />
        <Route path="profile-rohre" element={<Blechbedarf kat="profilrohr" />} />
        <Route path="sonstiges" element={<Blechbedarf kat="sonstiges" />} />
        <Route path="einkauf-anfragen" element={<EinkaufSonstiges />} />
        <Route path="banf" element={<SammelBestellung />} />
        <Route path="banf/:id" element={<SammelZettel />} />
        <Route path="artikelstamm" element={<Artikelstamm />} />
        <Route path="sammelbestellung" element={<Navigate to="/banf" replace />} />
        <Route path="sammelbestellung/:id" element={<SammelZettelUmleitung />} />
        <Route path="gas" element={<GasBestellung />} />
        <Route path="sonderteile" element={<Sonderteile />} />
        <Route path="lieferanten" element={<Lieferanten />} />
        <Route path="kundeninfo" element={<KundenInfo />} />
        <Route path="kunden" element={<Kunden />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="meine-tickets" element={<MeineTickets />} />
        <Route path="einstellungen" element={<Einstellungen />} />
      </Route>
    </Routes>
  );
}
